import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Collapse from '@mui/material/Collapse';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import ConstituentRecurringDonationsTable from './ConstituentRecurringDonationsTable';

export default function ConstituentRecurringDonationsContainer({ data }) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  if (!data?.length) {
    return null;
  }

  const calculatePlanCount = (plans) => {
    let count = 0;
    plans.forEach((plan) => {
      if (Object.keys(plan).length !== 0) count += 1;
    });
    return count;
  };

  return (
    <Collapse in={data} mountOnEnter>
      <Accordion
        className="rounded-lg bg-grey-100 shadow-none"
        expanded={isExpanded}
        data-testid="outstanding-pledges"
      >
        <AccordionSummary
          data-testid="recurring-donation-plans-toggle-button"
          expandIcon={<ArrowDropDownIcon />}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h3 className="type-h3">
            {translate('RECURRING_DONATION_PLANS', {
              count: calculatePlanCount(data),
            })}
          </h3>
        </AccordionSummary>
        <AccordionDetails>
          <div className="flex w-full flex-col">
            <ConstituentRecurringDonationsTable data={data} />
          </div>
        </AccordionDetails>
      </Accordion>
    </Collapse>
  );
}

ConstituentRecurringDonationsContainer.propTypes = {
  data: PropTypes.array,
};

ConstituentRecurringDonationsContainer.defaultProps = {
  data: [],
};
